module.exports = "pegasus/assets/blocks/header-5-theme6.png";